<template>
  <div id="content" :class="{'bg-white': isWhitePage}">
    <transition name="fade" mode="out-in">
      <component @scroll-to="scrollTo" :is="currentContent" />
    </transition>
  </div>
</template>

<script>

import GpHome from "../pages/GpHome";
import GpSelect from "../pages/GpSelect";
import MatchTech from "../pages/MatchTech"
import Video from '@/pages/Video.vue'
import CancelBooking from "../pages/CancelBooking.vue";

const mappings = {
	gp: GpHome,
  gpSelect: GpSelect,
  matchTech: MatchTech,
  video: Video,
  cancelBooking: CancelBooking
};

export default {
  name: "ContentRouter",
  methods: {
    scrollTo(coordinates) {
      this.$emit("scroll-to", coordinates);
    },
  },
  computed: {
    currentContent() {
      return mappings[this.$route.name];
    },
    isWhitePage(){
      let whitePages = ['gp', 'gpSelect'];

      return whitePages.includes(this.$route.name)
    }
  },
};
</script>
<style lang="less">
#content {
  min-height: calc(100vh - 200px);
  display: flex;
  justify-content: center;
  & > div {
    width: 100%;
  }
}
.fade-enter-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease-in;
}
.fade-leave-active {
  transition-duration: 0s;
  transition-property: opacity;
  transition-timing-function: ease-in;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all 0s ease;
}
.slide-fade-enter
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}
</style>
